import cc from "classcat"

const ListItem = ({ bullet, item, textStyle }) => (
  <li>
    <div
      className={cc([
        "inline-flex cursor-default rounded-full py-2 pl-2 pr-4 font-display text-base leading-6",
        textStyle === "light" && "text-gray-100",
        textStyle === "dark" && "bg-zinc-800 text-zinc-50 hover:bg-zinc-800/50",
      ])}
    >
      <div className="mr-2 flex">{bullet}</div>
      <div className="flex items-center">
        <p className="">{item}</p>
      </div>
    </div>
  </li>
)

const List = ({ title = "", items, bullet, textStyle }) => {
  return (
    <div className="mx-auto">
      {title ? <h3>{title}</h3> : <></>}
      <ul className="flex list-none flex-wrap gap-2">
        {items.map((item) => (
          <ListItem
            item={item.title}
            key={item.id}
            bullet={bullet}
            textStyle={textStyle}
          />
        ))}
      </ul>
    </div>
  )
}

export default List
